import { render, staticRenderFns } from "./jsaRelationDocu.vue?vue&type=template&id=39a32b17"
import script from "./jsaRelationDocu.vue?vue&type=script&lang=js"
export * from "./jsaRelationDocu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39a32b17')) {
      api.createRecord('39a32b17', component.options)
    } else {
      api.reload('39a32b17', component.options)
    }
    module.hot.accept("./jsaRelationDocu.vue?vue&type=template&id=39a32b17", function () {
      api.rerender('39a32b17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/jsa/plan/jsaRelationDocu.vue"
export default component.exports